import { render } from "./TeamView.vue?vue&type=template&id=7bc8c440&scoped=true&ts=true"
import script from "./TeamView.vue?vue&type=script&lang=ts"
export * from "./TeamView.vue?vue&type=script&lang=ts"

import "./TeamView.vue?vue&type=style&index=0&id=7bc8c440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc8c440"]])

export default __exports__